import {
  FaultQueryRequest,
  FaultQueryResponse,
  FaultSubmitRequest,
  FaultSubmitResponse,
} from '@/interface/services/problemAssistant';
import request from '../utils/request';
import appConst from '../const/app.const';

export default class {
  /**
   * @description 骑行故障查询接口
   * @yapi https://yapi.hellobike.cn/project/42/interface/api/107778
   */
  static faultQuery(params: FaultQueryRequest): Promise<FaultQueryResponse> {
    return request.post(
      {
        action: 'user.ev.ride.normal.fault.query',
        systemCode: 65,
        ...params,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    );
  }

  /**
   * @description 骑行故障上报接口
   * @yapi https://yapi.hellobike.cn/project/42/interface/api/107610
   */
  static faultSubmit(params: FaultSubmitRequest): Promise<FaultSubmitResponse> {
    return request.post(
      {
        action: 'user.ev.ride.normal.fault.submit',
        systemCode: 65,
        ...params,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    );
  }
}
